import { motion } from 'framer-motion';
import { useState } from 'react';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: 'Como funciona o transporte empresarial?',
      answer: 'Solicitação Rápida: Você pode solicitar nosso serviço através do nosso site ou WhatsApp em poucos cliques. Agendamento Flexível: Oferecemos opções de agendamento para que você possa escolher o melhor horário para a coleta ou entrega.',
    },
    {
      question: 'Quais regiões a RBF Express atende?',
      answer: 'Atendemos São José dos Campos e outras cidades do Vale do Paraíba, Grande São Paulo, Sul de Minas Gerais, Rio de Janeiro e outras localidades sob consulta. Entre em contato para verificar disponibilidade na sua região.',
    },
    {
      question: 'Atende fora do horário comercial?',
      answer: 'Nós funcionamos das 08h às 17h30. Serviços fora do horário precisam ser consultados e verificados quanto à disponibilidade. Entre em contato via WhatsApp para solicitar atendimento especial.',
    },
    {
      question: 'É possível contrato mensal?',
      answer: 'Sim! Oferecemos tanto atendimento sob demanda quanto contratos mensais fixos para empresas que necessitam de serviços logísticos regulares. Fale com nosso especialista para conhecer as opções.',
    },
    {
      question: 'Como solicitar orçamento rápido?',
      answer: 'Entre em contato via WhatsApp (12) 99106-4271 ou através dos botões de contato no site. Nossa equipe responde rapidamente com uma cotação personalizada para suas necessidades logísticas.',
    },
  ];

  return (
    <section id="faq" className="bg-white py-20">
      <div className="container mx-auto px-6 lg:px-20">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl lg:text-4xl font-bold text-[#1a237e] mb-4">Perguntas Frequentes</h2>
        </motion.div>

        <div className="max-w-3xl mx-auto">
          {faqs.map((faq, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="border-b border-gray-200"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full py-6 flex items-center justify-between text-left hover:bg-[#f8f9fa]/50 transition-all px-4 cursor-pointer"
              >
                <h3 className="text-lg font-semibold text-[#1a237e] pr-8">{faq.question}</h3>
                <i
                  className={`ri-${openIndex === index ? 'subtract' : 'add'}-line text-2xl text-[#ff6f00] flex-shrink-0 transition-transform duration-300 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96 pb-6' : 'max-h-0'
                }`}
              >
                <p className="text-gray-700 leading-relaxed px-4">{faq.answer}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
